module.exports = __webpack_public_path__ + "static/media/icons-ic-email-sent.149efb2f.svg";